import React, {useState, useEffect} from 'react';
import MetaTags from 'react-meta-tags';  // Added Meta Tag npm Package
import { Link } from 'react-router-dom';
import { Row, Col, Container, Card, CardBody, CardTitle, Modal, Form, Label, Input, UncontrolledDropdown } from "reactstrap"

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

import axios from 'axios';
import * as url from 'helpers/url_helper';
import { Config, TOAST_OPTIONS, validateSomaliaPhoneNumber } from 'helpers/backend_helper';
import toastr from "toastr";
import "toastr/build/toastr.min.css";

import { Button,  DropdownToggle,  DropdownMenu,  DropdownItem,  ButtonDropdown, Table} from "reactstrap";
import LoadingOverlay from 'react-loading-overlay';
import BounceLoader from 'react-spinners/BounceLoader'
import Swal from 'sweetalert2';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

    const ComplaintMessages = () => {

        toastr.options = TOAST_OPTIONS;
        const [modal_language, setmodal_language] = useState(false);
        const [isEdit, setIsEdit] = useState(false);
        const [languages, setLanguages] = useState([])
        const [isLoading, setIsLoading] = useState(false)

        const [languageName, setLanguageName] = useState('')
        const [languageId, setLanguageId] = useState('')

        const [receiveSMS, setReceiveSMS] = useState('')
        const [receiveSubject, setReceiveSubject] = useState('')
        const [receiveEmail, setReceiveEmail] = useState('')

        const [assignedSMS, setAssignedSMS] = useState('')
        const [assignedSubject, setAssignedSubject] = useState('')
        const [assignedEmail, setAssignedEmail] = useState('')

        const [handledSMS, setHandledSMS] = useState('')
        const [handledSubject, setHandledSubject] = useState('')
        const [handledEmail, setHandledEmail] = useState('')

        const [assignedToYouSMS, setAssignedToYouSMS] = useState('')
        const [assignedToYouSubject, setAssignedToYouSubject] = useState('')
        const [assignedToYouEmail, setAssignedToYouEmail] = useState('')

        const [handledByYouSMS, setHandledByYouSMS] = useState('')
        const [handledByYouSubject, setHandledByYouSubject] = useState('')
        const [handledByYouEmail, setHandledByYouEmail] = useState('')

        const removeBodyCss = () => {
          document.body.classList.add("no_padding");
        }
        const tog_language = () => {
          fetchData()
          setmodal_language(!modal_language)
          removeBodyCss()
        }

        const fetchData = () => {
          setIsLoading(true)
          axios.get(url.MESSAGES, Config).then((r)=>{ 
            setLanguages(r.data); 
            setIsLoading(false)
          }).catch((e)=>{  
            console.log(e); 
            setIsLoading(false)
          });
         
        }
        
        useEffect(() => {
          fetchData();
        },[]);
        const handleAddNewLanguage = () =>{
            setIsEdit(false)
            clearData()
            tog_language()
        }
        const clearData =() =>{
            setLanguageName('')
            setReceiveSMS('')
            setReceiveSubject('')
            setReceiveEmail('')
            setAssignedSMS('')
            setAssignedSubject('')
            setAssignedEmail('')
            setHandledSMS('')
            setHandledSubject('')
            setHandledEmail('')
            setAssignedToYouSMS('')
            setAssignedToYouSubject('')
            setAssignedToYouEmail('')
            setHandledByYouSMS('')
            setHandledByYouSubject('')
            setHandledByYouEmail('')
        }
        const handleSave = () =>{
          if(languageName.trim().length < 2){
            toastr.error("Enter language name")
          }else{
            let data = {}
            if(isEdit){
              data = {
                id:             languageId,
                language:       languageName,
                receiveSMS:     receiveSMS,
                receiveSubject: receiveSubject,
                receiveEmail:   receiveEmail,
                assignedSMS:    assignedSMS,
                assignedSubject: assignedSubject,
                assignedEmail:  assignedEmail,
                handledSMS:     handledSMS,
                handledSubject: handledSubject,
                handledEmail:   handledEmail,
                assignedToYouSMS: assignedToYouSMS,
                assignedToYouSubject: assignedToYouSubject,
                assignedToYouEmail: assignedToYouEmail,
                handledByYouSMS: handledByYouSMS,
                handledByYouSubject: handledByYouSubject,
                handledByYouEmail: handledByYouEmail,
                action:         "edit"
              }
            }else{
              data = {
                language:       languageName,
                receiveSMS:     receiveSMS,
                receiveSubject: receiveSubject,
                receiveEmail:   receiveEmail,
                assignedSMS:    assignedSMS,
                assignedSubject: assignedSubject,
                assignedEmail:  assignedEmail,
                handledSMS:     handledSMS,
                handledSubject: handledSubject,
                handledEmail:   handledEmail,
                assignedToYouSMS: assignedToYouSMS,
                assignedToYouSubject: assignedToYouSubject,
                assignedToYouEmail: assignedToYouEmail,
                handledByYouSMS: handledByYouSMS,
                handledByYouSubject: handledByYouSubject,
                handledByYouEmail: handledByYouEmail,
                action: "add"
              }
            }
            
            setIsLoading(true)
            axios.post(url.MESSAGES, JSON.stringify(data), Config).then((r)=>{
              if(r.data.status == '1'){
                toastr.success(r.data.message)
                tog_language()
                setIsEdit(false)
                clearData()
              }else{
                toastr.error(r.data.message)
              }
              setIsLoading(false)
            }).catch((e)=>{
              console.log(e)
              setIsLoading(false)
            })
          }
        }
       
        const handleClickDetails = (c) =>{
          setIsEdit(true)
          setLanguageId(c.id)
          setLanguageName(c.lang)
          setReceiveSMS(c.receivedSMS)
          setReceiveSubject(c.receivedSubject)
          setReceiveEmail(c.receivedEmail)
          setAssignedSMS(c.assignedSMS)
          setAssignedSubject(c.assignedSubject)
          setAssignedEmail(c.assignedEmail)
          setHandledSMS(c.handledSMS)
          setHandledSubject(c.handledSubject)
          setHandledEmail(c.handledEmail)
          setAssignedToYouSMS(c.assignedToYouSMS)
          setAssignedToYouSubject(c.assignedToYouSubject)
          setAssignedToYouEmail(c.assignedToYouEmail)
          setHandledByYouSMS(c.handledByYouSMS)
          setHandledByYouSubject(c.handledByYouSubject)
          setHandledByYouEmail(c.handledByYouEmail)
          tog_language()
        }
       
        return (
            <>
              <LoadingOverlay
                active={isLoading}
                spinner={<BounceLoader />}
                text='Please wait...'
                >
                <div className="page-content">
                    <MetaTags>
                    <title>Messages | {url.COMPANY}</title>
                    </MetaTags>
                    <Container fluid={true}>
                        <Row>
                                      

                            <Col lg="12">
                            <Card>
                                <CardBody>

                                <Modal isOpen={modal_language} toggle={() => { tog_language(); }}  size="xl" centered  backdrop={'static'}  >
                                  <div className="modal-header">
                                    <h5 className="modal-title mt-0" id="myModalLabel">{ isEdit? `Update Language`:`Add language` }</h5>
                                    <button type="button"  onClick={() => { setmodal_language(false);  }}  className="close" data-dismiss="modal"aria-label="Close">
                                      <span aria-hidden="true">&times;</span>
                                    </button>
                                  </div>
                                  <div className="modal-body">
                                  <Row>
                                        <Col md={12}>
                                            <div className="mb-3">
                                                <label>Language</label>
                                                <input type='text' className="form-control" value={languageName} onChange={(e)=>setLanguageName(e.target.value)} />
                                            </div>
                                        </Col>
                                        <Col md={12}>
                                            <div className="mb-3">
                                                <label>Complaint received SMS to customer</label>
                                                <textarea className="form-control" rows={3} value={receiveSMS} onChange={(e)=>setReceiveSMS(e.target.value)} />
                                            </div>
                                        </Col>
                                        <Col md={12}>
                                            <div className="mb-3">
                                                <label>Complaint received email subject</label>
                                                <input type='text' className="form-control" value={receiveSubject} onChange={(e)=>setReceiveSubject(e.target.value)} />
                                            </div>
                                        </Col>
                                        <Col md={12}>
                                            <div className="mb-3">
                                                <label>Complaint received email to customer</label>
                                                <CKEditor
                                                  editor={ClassicEditor}
                                                  data={receiveEmail} 
                                                  onReady={editor => {
                                                    //console.log('Editor is ready to use!', editor);
                                                  }}
                                                  onChange={(event, editor) => {
                                                    //const data = editor.getData();
                                                    setReceiveEmail(editor.getData())
                                                  }}
                                                />
                                            </div>
                                        </Col>

                                    
                                        <Col md={12}>
                                            <div className="mb-3">
                                                <label>Complaint assigned SMS to customer</label>
                                                <textarea className="form-control" rows={3} value={assignedSMS} onChange={(e)=>setAssignedSMS(e.target.value)} />
                                            </div>
                                        </Col>
                                        <Col md={12}>
                                            <div className="mb-3">
                                                <label>Complaint assigned email subject</label>
                                                <input type='text' className="form-control" rows={6} value={assignedSubject} onChange={(e)=>setAssignedSubject(e.target.value)} />
                                            </div>
                                        </Col>
                                        
                                        <Col md={12}>
                                            <div className="mb-3">
                                                <label>Complaint assigned email to customer</label>
                                                <CKEditor
                                                  editor={ClassicEditor}
                                                  data={assignedEmail} 
                                                  onReady={editor => {
                                                    //console.log('Editor is ready to use!', editor);
                                                  }}
                                                  onChange={(event, editor) => {
                                                    setAssignedEmail(editor.getData())
                                                  }}
                                                />
                                            </div>
                                        </Col>
                                        <Col md={12}>
                                            <div className="mb-3">
                                                <label>Complaint handled SMS to customer</label>
                                                <textarea className="form-control" rows={3} value={handledSMS} onChange={(e)=>setHandledSMS(e.target.value)} />
                                            </div>
                                        </Col>
                                        <Col md={12}>
                                            <div className="mb-3">
                                                <label>Complaint handled email subject</label>
                                                <input type='text' className="form-control" value={handledSubject} onChange={(e)=>setHandledSubject(e.target.value)} />
                                            </div>
                                        </Col>
                                        
                                        <Col md={12}>
                                            <div className="mb-3">
                                                <label>Complaint handled email to customer</label>
                                                <CKEditor
                                                  editor={ClassicEditor}
                                                  data={handledEmail} 
                                                  onReady={editor => {
                                                    //console.log('Editor is ready to use!', editor);
                                                  }}
                                                  onChange={(event, editor) => {
                                                    setHandledEmail(editor.getData())
                                                  }}
                                                />
                                            </div>
                                        </Col>
                                                  <hr/>
                                        <Col md={12}>
                                            <div className="mb-3">
                                                <label>Complaint Assigned to you (SMS to staff)</label>
                                                <textarea className="form-control" value={assignedToYouSMS} onChange={(e)=>setAssignedToYouSMS(e.target.value)} />
                                            </div>
                                        </Col>
                                        <Col md={12}>
                                            <div className="mb-3">
                                                <label>Complaint Assigned to you email subject</label>
                                                <input type='text' className="form-control" value={assignedToYouSubject} onChange={(e)=>setAssignedToYouSubject(e.target.value)} />
                                            </div>
                                        </Col>
                                        
                                        <Col md={12}>
                                            <div className="mb-3">
                                                <label>Complaint Assigned to you (Email to staff)</label>
                                                <CKEditor
                                                  editor={ClassicEditor}
                                                  data={assignedToYouEmail} 
                                                  onReady={editor => {
                                                    //console.log('Editor is ready to use!', editor);
                                                  }}
                                                  onChange={(event, editor) => {
                                                    setAssignedToYouEmail(editor.getData())
                                                  }}
                                                />
                                            </div>
                                        </Col>
                                        <Col md={12}>
                                            <div className="mb-3">
                                                <label>Complaint has been resolved (SMS to staff)</label>
                                                <textarea className="form-control" value={handledByYouSMS} onChange={(e)=>setHandledByYouSMS(e.target.value)} />
                                            </div>
                                        </Col>
                                        <Col md={12}>
                                            <div className="mb-3">
                                                <label>Complaint has been resolved email subject (to staff)</label>
                                                <input type='text' className="form-control" value={handledByYouSubject} onChange={(e)=>setHandledByYouSubject(e.target.value)} />
                                            </div>
                                        </Col>
                                        
                                        <Col md={12}>
                                            <div className="mb-3">
                                                <label>Complaint has been resolved (Email to staff)</label>
                                                <CKEditor
                                                  editor={ClassicEditor}
                                                  data={handledByYouEmail} 
                                                  onReady={editor => {
                                                    //console.log('Editor is ready to use!', editor);
                                                  }}
                                                  onChange={(event, editor) => {
                                                    setHandledByYouEmail(editor.getData())
                                                  }}
                                                />
                                            </div>
                                        </Col>
                                  </Row>
                                  </div>
                                  
                                  <div className="modal-footer">
                                  {isLoading ? 
                                        (<button type="button" className="btn btn-secondary" disabled={true}>Please wait...</button>)
                                      : ( <button type="button" className="btn btn-success" onClick={()=>handleSave()}>Save...</button> )
                                  }</div>
                                </Modal>

                                <div>
                                    <Row className="mb-3">
                                    <Col xl={6} sm={6}>
                                        <div className="mt-2">
                                        <h5>{``}</h5>
                                        </div>
                                    </Col>
                                    <Col xl={6} sm={6}>
                                        <Form className="mt-4 mt-sm-0 float-sm-end d-flex align-items-center">
                                        <div className="search-box mb-2 me-2">
                                           
                                        </div>
                                        <UncontrolledDropdown className="mb-0" direction="right">
                                            <DropdownToggle
                                            color="white"
                                            className="btn btn-link text-muted mt-n2"
                                            onClick={()=>{handleAddNewLanguage()}}
                                            >
                                            <i className="mdi mdi-book-plus-multiple font-size-24 text-success"></i>
                                            </DropdownToggle>
                                        </UncontrolledDropdown>
                                        </Form>
                                    </Col>
                                    </Row>
                                </div>
                                
                                <div className="table">
                                  <Table className="table table-sm m-0">
                                    <thead>
                                      <tr>
                                        <th>No</th>
                                        <th>Name</th>
                                        <th>Complaint Received SMS</th>
                                        
                                        <th></th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                    {languages.map((c,k)=>(
                                      <tr key={k}>
                                        <td>{k+1}</td>
                                        <td>{c.lang}</td>
                                        <td>{c.receivedSMS}</td>
                                        <td>
                                        <div className="d-flex gap-3">
                                         
                                            <Button
                                                  type="button"
                                                  color="info"
                                                  className="btn-sm btn-rounded"
                                                  onClick={()=>{handleClickDetails(c)}}
                                                >
                                                  Details
                                            </Button>
                                          </div>
                                        </td>
                                      </tr>
                                    ))} 
                                    </tbody>
                                                          
                                  </Table>
                                </div>

                                </CardBody>
                            </Card>
                            </Col>
                        </Row>

                        
                           

                    </Container>
                </div>
                </LoadingOverlay>
            </>
        );
    }

export default ComplaintMessages;